import {useMutation} from "@tanstack/react-query";
import {HistorySearchParamType} from "../interface";
import moment from "moment";
import {exportHistoryExcel} from "../../../../api/inventory/HistoryApi";
import {downloadFile} from "../../../../util/FileDownload";

export const useExportHistoryExcel = () => {
    const {mutate} = useMutation({
        mutationFn: (data: HistorySearchParamType) => exportHistoryExcel(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                const now = moment().format("YYYY_MM_DD_hh_mm")

                downloadFile(res, `재고_내역_${now}.xlsx`)
            }
        },
    });

    return {mutate};
};
